module.exports = __webpack_public_path__ + "assets/img/script_watch.817ce32f.jpg";